import { Alert, Box } from "@mui/material";
import { useEffect, useState } from "react";
import { getSendingSuspensions, type SendingSuspensions } from "../api/userprofile";

/**
 * App-wide banner listing ALL currently-paused senders (e.g. after a Microsoft 5.1.8
 * outbound block). Shown to admin + staff so they can act — e.g. unblock the mailbox
 * in the provider portal. The backend returns an empty list for non-staff viewers.
 */
export const SendingSuspensionBanner = () => {
	const [data, setData] = useState<SendingSuspensions | null>(null);

	useEffect(() => {
		let mounted = true;
		const load = () => {
			getSendingSuspensions()
				.then((d) => {
					if (mounted) setData(d);
				})
				.catch(() => {});
		};
		load();
		const id = window.setInterval(load, 60000);
		return () => {
			mounted = false;
			window.clearInterval(id);
		};
	}, []);

	if (!data || data.paused.length === 0) return null;

	return (
		<Box data-component="sending-suspension-banner">
			<Alert severity="error" data-component="sending-suspension-list">
				{data.paused.length} mailbox
				{data.paused.length > 1 ? "es are" : " is"} paused from sending (likely
				a provider outbound block — unblock in the provider portal):{" "}
				{data.paused
					.map(
						(u) =>
							`${u.email} (until ${new Date(u.until).toLocaleString()})`
					)
					.join("; ")}
			</Alert>
		</Box>
	);
};
